//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    treeCatalogReciver: {
      type: Array,
      default: null
    },
    parentId: {
      type: Number,
      default: null
    }
  },
  data: function () {
    return {
      thumbStyle: {
        right: '4px',
        borderRadius: '5px',
        background: '#A9A9A9',
        width: '10px',
        opacity: 1
      },
      movedReceiver: null,
      receiver: { name: '...КОРНЕВОЙ КАТАЛОГ', descr: '' }
    }
  },
  watch: {
    movedReceiver: function (receiverId) {
      this.setMovedReceiverObject(receiverId)
    }
  },
  methods: {
    setMovedReceiverObject: function (receiverId) {
      if (receiverId) {
        const res = this.receiver
        this.treeCatalogReciver.map(a => ({ ...a })).filter(function findPoint (e) {
          if (e.id == receiverId) {
            res.name = e.label
            res.descr = e.descr
          }
          return e.id == receiverId || (e.children && (e.children.filter(findPoint)).length)
        })
        this.receiver = res
      } else {
        this.receiver = { name: '...КОРНЕВОЙ КАТАЛОГ', descr: '' }
      }
      this.$emit('set-moved-receiver', { id: receiverId, name: this.receiver.name })
    }
  }
}
